import { MediaMatcher } from '@angular/cdk/layout';
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, ViewChild } from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { onMainContentChange } from '../../animations/animations';
import { SidenavService } from '../../services/sidenav/sidenav.service';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  animations: [ onMainContentChange ]
})
export class MainLayoutComponent implements AfterViewInit, OnDestroy {
    pageTitle = '';
    mobileQuery!: MediaQueryList;
    mobileTopGapQuery!: MediaQueryList;
    topGapMobile = 56;
    topGapLarge = 64;
    public onSideNavChange!: boolean;
    public mainContentChange: boolean = true;

    @ViewChild('snav') sidenav!: MatSidenav;

    private mobileQueryListener!: () => void;

    constructor(private changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, router: Router, activatedRoute: ActivatedRoute, private _sidenavService: SidenavService) {
        const self = this;
        self.mobileQuery = media.matchMedia('(max-width: 1280px)');
        // self.mobileQuery = media.matchMedia('(max-width: 768px)');
        self.mobileTopGapQuery = media.matchMedia('(max-width: 599px)');
        self.mobileQueryListener = () => changeDetectorRef.detectChanges();
        self.mobileQuery.addEventListener("change", self.mobileQueryListener);
        self.mobileTopGapQuery.addEventListener("change", self.mobileQueryListener);
        router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                self.pageTitle = activatedRoute.firstChild?.snapshot.data?.['title'];
            }
        });

        self._sidenavService.sideNavState$.subscribe( res => {
            self.onSideNavChange = res;
        });
        
        self._sidenavService.mainContentChange$.subscribe((res) => {
            self.mainContentChange = res;
        });
    
        if (self.mobileQuery.matches) {
            self._sidenavService.mainContentChange$.next(false);
        }
    }
    
    ngAfterViewInit(): void {
        this.changeDetectorRef.detectChanges();
    }

    closedStart() {
        this._sidenavService.mainContentChange$.next(false);
    }

    openedStart() {
        this._sidenavService.mainContentChange$.next(true);
    }

    expandBeforeToggle() {
        this._sidenavService.sideNavState$.next(true);
        this._sidenavService.animateText$.next(true);
        setTimeout(() => {
            this.sidenav.toggle();
        }, 100);
    }

    toggleSidenav() {
        this.mobileQuery.matches
            ? this.expandBeforeToggle()
            : this.sidenav.toggle();
    }

    ngOnDestroy(): void {
        this.mobileQuery.removeEventListener("change", this.mobileQueryListener);
        this.mobileTopGapQuery.removeEventListener("change", this.mobileQueryListener);
    }
}